import { DrEntity } from './dr-entity';

export class LoggedUser extends DrEntity {
    firstName: string;
    lastName: string;
    email: string;
    userIpAddress: string;
    lastPollTime: string;
    projectName: string;
    projectDescription: string;
    orgName: string;
    sessionDuration: string;
    sessionTime: string;
    idleDuration: string;
    deviceID: string;
    isCurrentUser = false;

    constructor(value?: Partial<LoggedUser>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}